const crx = /\s*(.*?)=(.*?)($|;|,(?! ))/g;
export const storage = {
    setItem(name, data) {
        return localStorage.setItem(name, data);
    },
    getItem(name) {
        return localStorage.getItem(name);
    },
    removeItem(name) {
        return localStorage.removeItem(name);
    },
};
export const cookie = {
    setItem(name, data, expires = '') {
        const domain = location.hostname;
        const domainPart = domain ? `domain=.${domain};` : '';
        document.cookie = `${name}=${encodeURIComponent(data)};expires="${expires}";path=/;${domainPart}`;
    },
    getItem(name) {
        return document.cookie.replace(crx, (_m, p1, p2) => (name === p1 ? p2 : ''));
    },
    removeItem(name) {
        this.setItem(name, '', '-1');
    },
};
//# sourceMappingURL=storage.js.map